import { useLocation } from 'react-router-dom';

export const useAuthPageCheck = () => {
  const location = useLocation();
  const pathname = location.pathname.toLowerCase();

  const isSigninPage = pathname === '/signin';
  const isChangePasswordPage = pathname === '/changepassword';
  const isForgotPasswordPage = pathname === '/password';

  const isAuthPage = isSigninPage || isChangePasswordPage || isForgotPasswordPage;

  return {
    isSigninPage,
    isChangePasswordPage,
    isForgotPasswordPage,
    isAuthPage,
  };
};
